export default {
	name: 'Convention.Schedule.Discover.Interest',
	path: 'convention/schedule/discover/interests/:id',
	meta: {
		auth: true,
		api: 'convention/schedule/discover/interests',
		parents: ['Convention.Schedule.Discover']
	},
	delete: {
		api: 'convention/schedule/discover/interests',
		complete: 'Convention.Schedule.Discover.Interests',
		noun: 'interest'
	}
}